<template>
  <div class="shop-form__block">
    <div class="finish" v-if="!store.state.authModule.tokens">

      <div class="text">
        Мы отправили вам код на WhatsApp
      </div>

      <div
        :class="{
          '_loader _loader-20px': store.state.authModule.authCodeLoading,
        }"
      >
        <div
          class="inputwrapper"
          v-show="lastBlockStep === 0 && lastBlockStep !== 2"
        >
          <span class="errorblock" v-if="invalidAuthPhone"
            >Перепроверьте номер</span
          >
          <MaskInput
            v-model="store.state.authModule.authPhone"
            :class="{ error: invalidAuthPhone }"
            ref="authPhoneInput"
            class="input"
            type="tel"
            :mask="
              store.state.authModule.authPhone.includes('+7')
                ? '+# ### ### ## ##'
                : '+#############'
            "
            placeholder="+7 *** *** ** **"
          />
        </div>
        <div
          class="inputwrapper"
          v-show="lastBlockStep === 1 && lastBlockStep !== 2"
        >
          <span class="errorblock" v-if="invalidAuthCode">Неверный код</span>
          <MaskInput
            mask="# # # #"
            v-model="store.state.authModule.authCode"
            :class="{ error: invalidAuthCode }"
            class="input"
            placeholder="Введите код"
          />
        </div>
        <button
          class="button bezh"
          v-if="lastBlockStep !== 2"
          @click="nextAuthStep"
        >
          {{ lastBlockStep === 0 ? "Запросить код" : "Подтвердить" }}
        </button>
      </div>

      <div v-if="lastBlockStep === 1">
        <codeTimer :retryAfter="retryAfterCodeTimer">
          <button class="button bezh" @click="reSendCode">
            Запросить код повторно
          </button>
        </codeTimer>
      </div>
      
    </div>

    <div class="confirm" v-else>
        <span class="number">{{ store.state.authModule.authPhone }}</span>
        <span class="ready">Подтверждено</span>
      </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, defineExpose } from "vue";
import { useStore } from "vuex";
import { TypeLoyalityKinds } from "@/types";
import { IloyalityShopData } from "@/types/typesOfState";
import generateRandomString from "@/functions/generateRandomString";
import codeTimer from "@/components/code-timer.vue";

const store = useStore();

const currentLoyalityKind = computed<TypeLoyalityKinds>(
  () => store.state.currentLoyalityKind
);

const loyalityShopData = computed<IloyalityShopData>(
  () => store.state.loyalityShopData
);

const lastBlockStep = computed<number>(() => store.state.lastBlockStep)
let invalidAuthPhone = ref(false);
let invalidAuthCode = ref(false);
const authPhoneInput = ref<any>(null);
const retryAfterCodeTimer = ref(0);

function nextAuthStep(isCodeAgain: boolean): void {
  const authPhone = store.state.authModule.authPhone;
  const authCode = store.state.authModule.authCode;

  switch (lastBlockStep.value) {
    case 0:
      if (!authPhone || authPhone.replace(" ", "").length < 15) {
        invalidAuthPhone.value = true;
        authPhoneInput?.value?.$el.focus();
      } else {
        store.state.authModule.authPassword = generateRandomString(5);
        invalidAuthPhone.value = false;
        store.dispatch("authByCode").then((data) => {
          retryAfterCodeTimer.value = data.data.result.retry_after;
          store.state.lastBlockStep++;
        });
      }
      break;
    case 1:
      if (!authCode || authCode.length < 4) {
        invalidAuthCode.value = true;
      } else {
        store
          .dispatch("authByCode")
          .then((data) => {
            console.log("authByCode", data, data.data, data.data.result);
            invalidAuthCode.value = false;
            if (data.data.result) {
              const tokens = data.data.result.token;
              store.state.authModule.tokens = tokens;
              store.state.currentShopStep++
              store.state.authCode = ''
            }
          })
          .catch((err) => {
            store.state.authModule.authCodeLoading = false;
            store.state.authCode = ''
            if (
              err.response.data.errors.non_field_errors[0] ===
              "Неправильный проверочный код"
            ) {
              invalidAuthCode.value = true;
              store.state.authModule.authCode = "";
            }
          });
      }
      break;
  }
}

function reSendCode():void {
  store.state.authModule.authCode = null
  store.dispatch("authByCode").then((data) => {
          retryAfterCodeTimer.value = data.data.result.retry_after;
        });
}

defineExpose({ nextAuthStep });
</script>

<style></style>
